import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_secure-cinema-7/artifacts/2nir2hl5_Paradigm%20Logo.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Speaking", path: "/speaking" },
  { name: "Packages & FAQ", path: "/book" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" },
];

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMobileOpen]);

  return (
    <>
      <nav data-testid="navbar" className={`pg-navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="pg-container">
          <Link to="/" data-testid="logo-link" className="pg-nav-logo">
            <img src={LOGO_URL} alt="Paradigm Global Business Solutions" />
          </Link>

          <ul className="pg-nav-links">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  data-testid={`nav-${link.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className={location.pathname === link.path ? "active" : ""}
                >
                  {link.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/consultation" className="pg-btn pg-btn-primary" data-testid="nav-cta-button">
                Book Consultation
              </Link>
            </li>
          </ul>

          <button
            data-testid="mobile-menu-button"
            className="pg-nav-toggle"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-expanded={isMobileOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div data-testid="mobile-menu" className={`pg-mobile-menu ${isMobileOpen ? "open" : ""}`}>
        <button
          data-testid="mobile-menu-close"
          onClick={() => setIsMobileOpen(false)}
          style={{ position: "absolute", top: 20, right: 20, background: "none", border: "none", fontSize: "1.5rem", cursor: "pointer" }}
        >
          <i className="fas fa-times" />
        </button>
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            data-testid={`mobile-nav-${link.name.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => setIsMobileOpen(false)}
          >
            {link.name}
          </Link>
        ))}
        <Link to="/consultation" className="pg-btn pg-btn-primary" onClick={() => setIsMobileOpen(false)}>
          Book Consultation
        </Link>
      </div>
    </>
  );
};

export default Navbar;
